/**
 * MGT PDP Symptom Band
 * Desktop flips cards on hover (pure CSS). Touch devices have no hover, and the
 * CSS :hover fallback latched on first tap and never un-flipped — so bind a
 * reliable tap toggle there instead. Swiping through cards is native CSS
 * scroll-snap; a swipe never fires a click, so it won't accidentally flip.
 */
function initBandInstance(root) {
  root.querySelectorAll('.mgt-pdp-flip').forEach((card) => {
    card.addEventListener('click', () => {
      card.classList.toggle('is-flipped');
    });
  });
}

export default function initMgtSymptomBand() {
  // Only bind tap-to-flip where there's no hover; desktop keeps CSS hover-flip.
  if (!window.matchMedia('(hover: none)').matches) return;
  document.querySelectorAll('[data-mgt-band]').forEach(initBandInstance);
}
